<template>
  <div slot-scope="{ form, methods }" class="space-y-6">

    <vehicles-card :form="form" :methods="methods" />

    <div class="card">
      <div class="card-header">
        Conditions
      </div>
      <div class="p-6">
        <label class="form-label">If the vehicle has not had any activity for...</label>
        <div class="flex max-w-sm">
          <input type="number" v-model="form.threshold" class="form-input prepend" />
          <div class="form-suffix">hours</div>
        </div>
      </div>
    </div>

    <contacts-card :form="form" :methods="methods" />
    
    <monitor-card :form="form" :methods="methods" />
    
  </div>
</template>

<script>
  import ContactsCard from '@/views/automations/components/ContactsCard'
  import MonitorCard from '@/views/automations/components/MonitorCard'
  import VehiclesCard from '@/views/automations/components/VehiclesCard'
  
  export default {
    name: 'DriverLoginReminder',
    
    components: { 
      ContactsCard,
      MonitorCard,
      VehiclesCard
    },

    props: ['form', 'methods']
  }
</script>